window.locale = $('html').attr('lang');

$(function(){
    window.initAllOnObject($('body'));
});

window.initSelect2 = function(items=false){
    if(items === false){
        items = $('.select2');
    }    

    items.each(function(index, element){
        let settings = {
            'width': '100%',
        };
        if($(this).parents('.modal').length > 0){
            settings['dropdownParent'] = $(this).parents('.modal').eq(0);
        }

        $(element).select2(settings);
    });
}
window.initSelect2Tags = function(items=false){
    if(items === false){
        items = $('.select2_tags');
    }

    items.each(function(index, element){
        let settings = {
            'tags': true,
            'width': '100%',
        };
        if($(this).parents('.modal').length > 0){
            settings['dropdownParent'] = $(this).parents('.modal').eq(0);
        }
            
        $(element).select2(settings);
    });
}
window.initSelect2Ajax = function(items=false){
    if(items === false){
        items = $('.select2_ajax');
    }
            
    items.each(function(index, element){
        let settings = {
            'ajax': {
                'url': $(element).data('url'),
                'data': function(params){
                    let query = {};
                    if($(element).data('additional') != undefined){
                        query = JSON.parse($(element).data('additional'));
                    }

                    query['term'] = params.term; 
                    query['page'] = params.page || 1;

                    return query;
                }
            },
            'width': '100%',
        };
        if ($(element).data('select2-delay')) {
            settings['ajax']['delay'] = $(element).data('select2-delay');
        }
        if($(this).parents('.modal').length > 0){
            settings['dropdownParent'] = $(this).parents('.modal').eq(0);
        }
        
        $(element).select2(settings);
    });
}
window.initSelect2AjaxTags = function(items=false){
    if(items === false){
        items = $('.select2_ajax_tags');
    }

    items.each(function(index, element){
        let settings = {
            'tags': true,
            'ajax': {
                'url': $(element).data('url'),
                'data': function(params){
                    let query = {};
                    if($(element).data('additional') != undefined){
                        query = JSON.parse($(element).data('additional'));
                    }

                    query['term'] = params.term; 
                    query['page'] = params.page || 1;

                    return query;
                }
            },
            'width': '100%'
        };
        if ($(element).data('select2-delay')) {
            settings['ajax']['delay'] = $(element).data('select2-delay');
        }
        if($(this).parents('.modal').length > 0){
            settings['dropdownParent'] = $(this).parents('.modal').eq(0);
        }

        $(element).select2(settings);
    });
}
window.initDatePicker = function(items=false){
    if(items === false){
        items = $('.datepicker');
    }

    let complete_locale = window.daterangepicker_locales[window.locale];
    complete_locale['format'] = 'YYYY-MM-DD';

    items.daterangepicker({
        'singleDatePicker': true,
        'autoApply': true,
        'locale': complete_locale
    });

    items.attr('autocomplete', 'off');
}
window.initDateTimePicker = function(items=false){
    if(items === false){
        items = $('.datetimepicker');
    }

    let complete_locale = window.daterangepicker_locales[window.locale];
    complete_locale['format'] = 'YYYY-MM-DD HH:mm';

    items.daterangepicker({
        'singleDatePicker': true,
        'autoApply': true,
        'locale': complete_locale,
        'timePicker': true,
        'timePicker24Hour': true,
    });

    items.attr('autocomplete', 'off');
}
window.initAutonumeric = function(items=false){
    if(items === false)
        items = $('.autonumeric');

    items.each(function(index, element){
        new Autonumeric(element, {
            'decimalCharacter': $(element).attr('data-decimal-character') ? $(element).attr('data-decimal-character') : '.',
            'digitGroupSeparator': $(element).attr('data-thousands-separator') ? $(element).attr('data-thousands-separator') : ' ',
            'decimalPlaces': $(element).attr('data-decimal-places') ? $(element).attr('data-decimal-places') :  2,
        })
    });

    items.attr('autocomplete', 'off');
}

window.initAllOnObject = function(object){
    object = $(object);

    window.initSelect2(object.find('.select2'));
    window.initSelect2Tags(object.find('.select2_tags'));
    window.initSelect2Ajax(object.find('.select2_ajax'));
    window.initSelect2AjaxTags(object.find('.select2_ajax_tags'));
    window.initDatePicker(object.find('.datepicker'));
    window.initDateTimePicker(object.find('.datetimepicker'));
    window.initAutonumeric(object.find('.autonumeric'));
}

window.showUploadImage = function(input){
    if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (event) {
            let block = $(input).parent().find('.uploaded_image');
            block.attr('src', event.target.result);
            block.removeClass('d-none');
            block.addClass('d-block');
        }
        
        reader.readAsDataURL(input.files[0]);
    }
}

window.findTableComponentById = function(table_id){
    let vueComponent = false;
    $.each(window.vueApp.$children, function(index, element){
        if((element.table_id || '') === table_id){
            vueComponent = element;
            return false;
        }
    });
    return vueComponent;
}